import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';

export const ArticleTakeaways = ({ takeaways }) => {
  if (!takeaways || takeaways.length === 0) return null;

  return (
    <section className="bg-stone-50 border-y border-stone-200" data-testid="article-takeaways">
      <div className="container-portico py-10 md:py-14">
        <h2 className="font-heading text-lg md:text-xl font-semibold text-stone-800 mb-6 flex items-center gap-2">
          <Lightbulb className="w-5 h-5 text-primary" />
          Key Takeaways
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {takeaways.map((item, i) => (
            <motion.div
              key={item.label || `takeaway-${i}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06, duration: 0.35 }}
              className="bg-white rounded-lg border border-stone-200 p-5 shadow-sm"
              data-testid={`takeaway-${i}`}
            >
              <p className="text-sm font-semibold text-primary mb-1">{item.label}</p>
              <p className="text-sm text-stone-600 leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
